import { createSelector } from 'reselect';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getZeroState } from '../../zero-state/selectors/getZeroState';
import { isEmailSetup } from '../../zero-state/operators/getters';
export const getIsEmailSetup = createSelector([getCurrentInboxId, getZeroState], (currentInboxId, zeroState) => {
  return isEmailSetup(currentInboxId, zeroState);
});